import React from 'react';
import { cn } from '../../lib/utils';
import { ScrollArea } from '../ui/scroll-area';

interface SidebarProps {
  collapsed: boolean;
  children: React.ReactNode;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed, children }) => {
  return (
    <aside
      className={cn(
        "hidden lg:flex flex-col border-r bg-card transition-all duration-300 overflow-hidden",
        collapsed ? "w-0 border-r-0" : "w-[370px]"
      )}
    >
      <ScrollArea className="flex-1">
        <div className="flex flex-col p-4 gap-0 min-w-0">
          {children}
        </div>
      </ScrollArea>
    </aside>
  );
};

export default Sidebar;
